import { INVESTMENT_FLOW_MAPPER } from "../../constants/mf";
import { formatAmountInr } from "../common/functions";
import { isNfoFlow } from "../mf/validators";

export const getIsins = (fundsData) => {
  let isinArr = fundsData.map((data) => {
    return data.isin;
  });
  return isinArr.join(",");
};

export const getFundLogoAndIsin = (fundsData) => {
  return fundsData.map((data) => {
    return { isin: data.isin, logo: data.amc_logo_small };
  });
};

export const validateMfOrderFunds = (
  amount,
  min,
  max,
  multiple,
  flowType = INVESTMENT_FLOW_MAPPER.diy
) => {
  const isNfo = isNfoFlow(flowType);
  let defaultErrorAmount = `${formatAmountInr(min)} min.`;
  if (isNfo) {
    defaultErrorAmount = `Min. ${formatAmountInr(min)}`;
  }
  if (!amount) {
    return {
      message: defaultErrorAmount,
      showError: false,
    };
  }
  if (amount < min) {
    return {
      message: `Minimum investment amount is ${formatAmountInr(min)}`,
      showError: true,
    };
  } else if (amount % multiple !== 0) {
    return {
      message: `Amount must be multiple of ${formatAmountInr(multiple)}`,
      showError: true,
    };
  } else if (amount > max) {
    return {
      message: `Maximum amount for this fund is ${formatAmountInr(max)}`,
      showError: true,
    };
  } else {
    return {
      message: defaultErrorAmount,
      showError: false,
    };
  }
};
